
import React, { useState }  from 'react';

import axios from 'axios';
import ClipLoader from "react-spinners/ClipLoader";
import BreadCrumbs from "../BreadCrumbs/BreadCrumbs";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLineChart } from '@fortawesome/free-solid-svg-icons'; // chart-line  <i class="fa-solid fa-chart-line"></i>
import { Link } from "react-router-dom";



export default function SunChartFetchData({ server, apikey}) {

	const [fromDate, setFromDate] = useState(new Date().toISOString().slice(0, 10));
	const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
	const [auth, setAuth] = useState('');
	const [saving, setSaving] = useState(false);
	const [message, setMessage] = useState('');

	const onSubmitForm = (event) => {
		if (!auth) {
			setMessage('Data är tomt.');
			return;
		}
		// Create an object of formData
		const formData = new FormData();

		// Update the formData object
		formData.append("fromDate", fromDate);
		formData.append("toDate", toDate);
		formData.append("auth", auth);
		formData.append("plant", 'orjan');

		// Request made to the backend api
		// Send formData object
		axios.post(server+"sunchart/fetch?apikey="+apikey, formData)
			.then(response => {
				setMessage(response.data);
				setSaving(false);
			},
				reason => {
					setSaving(false);
					setMessage("Failed");
				});
		setSaving(true);
		setMessage('')
	}

	if (saving) {
		return (
			<ClipLoader loading={saving} size={50} />
		);
	}

	const showMessage = () => {
		if (!message) {
			return null;
		}
		return (<div className="errorMessage">{message}</div>);
	}


	return (
		<>
			{showMessage()}
			<label htmlFor="data"><b>Startdatum</b></label>
			<input type="date" name="fromDate" value={fromDate} onChange={(event) => {
				setFromDate(event.target.value)
			}}/>
			<br/>
			<label htmlFor="data"><b>Slutdatum</b></label>
			<input type="date" name="toDate" value={toDate} onChange={(event) => {
				setToDate(event.target.value)
			}}/>

			<br/>
			<label htmlFor="data"><b>Nyckel</b></label>
			<input type="text" name="auth" value={auth} onChange={(event) => {
				setAuth(event.target.value.startsWith('Bearer ') ? event.target.value.substring(7): event.target.value)
			}}/>
			<br/>
			<button type="button" name="fetchData" onClick={onSubmitForm}>Spara</button>

		</>
	);
}
